import { EntKurultaiRegisterFilter } from '../../../models/filters/kurultaiRegisterFilter'
import { EntKurultaiRegister } from '../../../models/kurultai/kutultaiRegister'
import { ResponseDataGet } from '../../../models/responseDataGet'
import { ResponseDataTest } from '../../../models/responseDataTest'
import { agroApi } from '../api'
import { Paths } from "../../../paths";

export const kurultaiRegisterApi = agroApi.injectEndpoints({
	endpoints: builder => ({
		getKurultaiRegisterListFiltered: builder.query<
			ResponseDataGet<EntKurultaiRegister>,
			EntKurultaiRegisterFilter
		>({
			query: filter => ({
				url: `${ Paths.kurultairegister }/get-all/monitoring`,
				method: 'POST',
				body: JSON.stringify(filter),
			}),
		}),
		getKurultaiRegisterById: builder.query<ResponseDataTest<EntKurultaiRegister>, number>({
			query: id => ({
				url: `${ Paths.kurultairegister }/${id}`,
				method: 'GET',
			}),
		}),
		addKurultaiRegister: builder.mutation<
			ResponseDataTest<EntKurultaiRegister>,
			EntKurultaiRegister
		>({
			query: body => ({
				url: `${ Paths.kurultairegister }`,
				method: 'POST',
				body: JSON.stringify(body),
			}),
		}),
		editKurultaiRegister: builder.mutation<
			ResponseDataTest<EntKurultaiRegister>,
			EntKurultaiRegister
		>({
			query: body => ({
				url: `${ Paths.kurultairegister }`,
				method: 'PUT',
				body: JSON.stringify(body),
			}),
		}),
		deleteKurultaiRegister: builder.mutation<ResponseDataTest<EntKurultaiRegister>, number>({
			query: id => ({
				url: `${ Paths.kurultairegister }/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
	overrideExisting: false,
})

export const {
	useAddKurultaiRegisterMutation,
	useDeleteKurultaiRegisterMutation,
	useEditKurultaiRegisterMutation,
	useGetKurultaiRegisterByIdQuery,
	useLazyGetKurultaiRegisterListFilteredQuery,
} = kurultaiRegisterApi
